import zelda from "../Assets/Zelda.png";
import luca from "../Assets/luca.png";
import marty from "../Assets/Marty.png";
import leah from "../Assets/Leah.png";
import sherman from "../Assets/sherman.png";
import anderson from "../Assets/anderson.png";
import hart from "../Assets/heart-attack.png";
import power from "../Assets/power.png";
import brain from "../Assets/brain.png";

export const characters = [
  {
    alt: "zelda",
    uri: zelda,
    delay: 800,
    hart: hart,
    power: power,
    brain: brain,
    hartValue: 100,
    powerValue: 100,
    brainValue: 100,
    name: "Zelda",
  },
  {
    alt: "luca",
    uri: luca,
    delay: 1100,
    hart: hart,
    power: power,
    brain: brain,
    hartValue: 70,
    powerValue: 40,
    brainValue: 50,
    name: "Luca",
  },
  {
    alt: "marty",
    uri: marty,
    delay: 1500,
    hart: hart,
    power: power,
    brain: brain,
    hartValue: 90,
    powerValue: 50,
    brainValue: 70,
    name: "Marty",
  },
  {
    alt: "leah",
    uri: leah,
    delay: 1900,
    hart: hart,
    power: power,
    brain: brain,
    hartValue: 80,
    powerValue: 80,
    brainValue: 60,
    name: "Leah",
  },
  {
    alt: "sherman",
    uri: sherman,
    delay: 2100,
    hart: hart,
    power: power,
    brain: brain,
    hartValue: 40,
    powerValue: 50,
    brainValue: 60,
    name: "Sherman",
  },
  {
    alt: "anderson",
    uri: anderson,
    delay: 2100,
    hart: hart,
    power: power,
    brain: brain,
    hartValue: 90,
    powerValue: 90,
    brainValue: 100,
    name: "Anderson",
  },
];

//   export const CBPDependencies = [
//     {
//       alt: "NodeJS",
//       uri: nodeJSLogo,
//       delay: 800,
//     },
//     {
//       alt: "React Bootstrap",
//       uri: reactBootstrapLogo,
//       delay: 1200,
//     },
//     {
//       alt: "JavaScript ",
//       uri: jsLogo,
//       delay: 1600,
//     },
//     {
//       alt: "MongoDB",
//       uri: MongoDBLogo,
//       delay: 1900,
//     },
//     {
//       alt: "React",
//       uri: ReactLogo,
//       delay: 2100,
//     },
//   ];
